var map = {
	"./cert/ru.yml": 533,
	"./email/ru.yml": 237,
	"./feedback/ru.yml": 648,
	"./frontpage/ru.yml": 949,
	"./groups/ru.yml": 243,
	"./models/ru.yml": 485,
	"./ru.yml": 962,
	"./signup/ru.yml": 19,
	"./teacher/ru.yml": 199
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 706;